import React from "react";

export function Section({ extraClasses, children }) {
  return (
    <section
      className={`py-16 md:py-20${extraClasses ? " " + extraClasses : ""}`}
    >
      {children}
    </section>
  );
}

export function Container({ extraClasses, children }) {
  return (
    <div className={`container ${extraClasses ? " " + extraClasses : ""}`}>
      {children}
    </div>
  );
}
